export default "__VITE_ASSET__Brr5kgx9__"